import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ActionErrorMessage from '../../components/ActionErrorMessage';
import AccountCard from './components/AccountCard';

export default function Account() {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountData, setAccountData] = useState(null);
  const initialState = { id: null };
  const [loadingError, setLoadingError] = useState(null);

  const onPageLoad = async () => {
    if (location.pathname.includes('new')) {
      setAccountData(initialState);
    } else if (location.pathname.includes('edit')) {
      try {
        setAccountData(location.state.account);
      } catch (error) {
        setLoadingError(error);
      }
    } else {
      navigate(-1);
    }
  };

  const onSaved = () => {
    navigate(-1);
  };

  useEffect(() => {
    onPageLoad();
  }, [location.pathname]);

  return (
    <Stack>
      {loadingError != null && <ActionErrorMessage error={loadingError} />}
      {accountData != null ? (
        <AccountCard
          isNewAccount={accountData.id == null}
          accountData={accountData}
          onSaved={onSaved}
        />
      ) : (
        <></>
      )}
    </Stack>
  );
}
